import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface AgentNodeDrawerFooterProps {
  onCancel: () => void
  onSubmit: () => void
}

export const AgentNodeDrawerFooter = ({
  onCancel,
  onSubmit,
}: AgentNodeDrawerFooterProps): ReactNode => (
  <div className="agent-node-drawer-footer flex justify-end gap-2 border-t px-6 py-4">
    <Button type="button" variant="outline" onClick={onCancel} className="agent-node-drawer-cancel">
      Cancel
    </Button>
    <Button type="button" onClick={onSubmit} className="agent-node-drawer-save">
      Save Changes
    </Button>
  </div>
)

AgentNodeDrawerFooter.displayName = 'AgentNodeDrawerFooter'
